import * as Select from "@radix-ui/react-select";
import { Check, ChevronDown } from "lucide-react";
// biome-ignore lint/style/useImportType: Classic JSX runtime requires React.
import React from "react";

export const AppSelect = <T extends string>({
  label,
  choices,
  contentClassName = "",
  disabled = false,
  onChange,
  value,
  placeholder,
}: {
  label: string;
  choices: Array<{ id: T; display: string; icon?: React.ReactNode; disabled?: boolean }>;
  placeholder?: string;
  contentClassName?: string;
  disabled?: boolean;
  onChange: (value: T) => void;
  value: T;
}) => (
  <Select.Root value={value} disabled={disabled} onValueChange={next => onChange(next as T)}>
    <Select.Trigger aria-label={label} className="dropdown-trigger w-full">
      <span className="min-w-0 flex-1 truncate">
        <Select.Value placeholder={placeholder} />
      </span>
      <Select.Icon asChild>
        <ChevronDown aria-hidden="true" className="h-4 w-4 shrink-0 text-text-dim" />
      </Select.Icon>
    </Select.Trigger>
    <Select.Portal>
      <Select.Content
        position="popper"
        sideOffset={6}
        align="start"
        collisionPadding={16}
        className={`dropdown-menu max-h-[var(--radix-select-content-available-height)] min-w-[var(--radix-select-trigger-width)] max-w-[calc(100vw-32px)] overflow-y-auto ${contentClassName}`}
      >
        <Select.Viewport>
          {choices.map(choice => (
            <Select.Item
              key={choice.id}
              value={choice.id}
              disabled={choice.disabled}
              textValue={choice.display}
              className="dropdown-option pl-8 data-[disabled]:pointer-events-none data-[disabled]:opacity-40"
            >
              <Select.ItemIndicator className="dropdown-check">
                <Check aria-hidden="true" className="h-4 w-4" />
              </Select.ItemIndicator>
              <Select.ItemText>
                <span className="flex min-w-0 items-center gap-2">
                  {choice.icon}
                  <span className="truncate">{choice.display}</span>
                </span>
              </Select.ItemText>
            </Select.Item>
          ))}
        </Select.Viewport>
      </Select.Content>
    </Select.Portal>
  </Select.Root>
);
